function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _objectWithoutProperties(_param, [
        "isDark"
    ]);
    var textColor = isDark ? "#FFFFFF" : "#000000";
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 145 44",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22 44C43.8304 44 44 34.1504 44 22C44 9.84958 43.8304 0 22 0C0.169583 0 0 9.84958 0 22C0 34.1504 0.169583 44 22 44Z",
                fill: "#20242E"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.6328 11H31.2372V15.5107H35.5V20.463H31.2372V25.1773C31.2372 26.9752 32.0643 27.7007 33.9412 27.7007C34.5138 27.7007 35.0228 27.6692 35.5 27.5746V32.5899C34.4502 32.8738 33.4004 33 32.3188 33C29.6148 33 27.7061 32.2114 26.529 30.6658C25.6701 29.4987 25.2247 28.0162 25.2247 26.2182V20.463H22.7116V15.501H23.2842H25.6383V13.8065L25.6328 11ZM14.8527 33C12.1115 33 9.66065 32.2315 7.5 30.7266L10.1121 26.7563C11.6923 27.8129 13.2725 28.3572 14.9172 28.3572C15.7879 28.3572 16.2394 28.1331 16.2394 27.6528C16.2394 27.3006 15.7556 26.9484 14.8204 26.5962L12.6275 25.7637C9.6929 24.643 8.20947 22.8179 8.20947 20.2884C8.20947 17.1826 10.8538 15.1333 14.9494 15.1333C17.5938 15.1333 19.8189 15.8378 21.6571 17.2146L18.9805 21.0889C17.9485 20.3524 16.2394 19.7761 14.9494 19.7761C14.3367 19.7761 14.0142 19.9682 14.0142 20.3204C14.0142 20.792 14.3873 20.9549 15.1639 21.294C15.1782 21.3003 15.1927 21.3066 15.2074 21.313L17.0778 22.0174C20.4317 23.2982 22.1731 24.8031 22.1731 27.5888C22.1731 30.9508 19.3997 33 14.8527 33Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M31.2375 20.463V15.5106H35.5V20.463H31.2375Z",
                fill: "#46B9FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M56.5463 27.0161C59.1574 27.0161 61.0185 25.7772 61.0185 23.8752V23.8664C61.0185 22.4443 60.0648 21.6416 58.0278 21.2315L56.3333 20.8913C55.2778 20.6732 54.8981 20.3765 54.8981 19.8617V19.853C54.8981 19.2074 55.5648 18.7973 56.5 18.7973C57.5093 18.7973 58.1111 19.2772 58.2593 19.7919L58.2685 19.8356H60.7778V19.8007C60.6667 18.2564 59.1852 17 56.5093 17C53.963 17 52.2593 18.204 52.2593 20.0101V20.0188C52.2593 21.4584 53.2222 22.357 55.1667 22.7497L56.8704 23.0899C57.9074 23.3081 58.3148 23.6309 58.3148 24.1456V24.1631C58.3148 24.8 57.6111 25.2188 56.5741 25.2188C55.5093 25.2188 54.8889 24.7913 54.6759 24.198L54.6574 24.1631H52L52.0093 24.198C52.2037 25.847 53.7778 27.0161 56.5463 27.0161Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M64.8889 26.8154H67.7222L69.5278 20.1148H69.6944L71.5185 26.8154H74.3889L77.1019 17.2094H74.4259L72.9074 24.1631H72.7407L70.9444 17.2094H68.3704L66.5833 24.1631H66.4167L64.8981 17.2094H62.1667L64.8889 26.8154Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M81.5278 26.9638C82.8611 26.9638 83.9352 26.4315 84.4537 25.5416H84.6204V26.8154H87.287V20.2544C87.287 18.204 85.7593 17 83.0556 17C80.4907 17 78.8056 18.1168 78.5926 19.8007L78.5833 19.8792H81.0833L81.1019 19.8443C81.3148 19.2772 81.9352 18.9544 82.9074 18.9544C84.0185 18.9544 84.6204 19.4255 84.6204 20.2544V21.0483L82.1574 21.1879C79.6204 21.3275 78.2037 22.3396 78.2037 24.0671V24.0846C78.2037 25.8295 79.5833 26.9638 81.5278 26.9638ZM80.8426 23.9275V23.9101C80.8426 23.2121 81.4074 22.802 82.5648 22.7322L84.6204 22.6101V23.3168C84.6204 24.3289 83.6852 25.1054 82.4352 25.1054C81.5 25.1054 80.8426 24.6604 80.8426 23.9275Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M89.9352 30H92.6389V25.2799H92.8056C93.3241 26.3268 94.463 26.9638 95.8611 26.9638C98.4444 26.9638 100 25.1054 100 22.0168V21.9993C100 18.9369 98.4074 17.0523 95.8611 17.0523C94.4167 17.0523 93.3333 17.6631 92.8056 18.6926H92.6389V17.2094H89.9352V30ZM94.9352 24.8523C93.5185 24.8523 92.6111 23.7792 92.6111 22.0168V21.9993C92.6111 20.2369 93.5093 19.1638 94.9352 19.1638C96.3704 19.1638 97.25 20.2369 97.25 21.9993V22.0168C97.25 23.7792 96.3611 24.8523 94.9352 24.8523Z",
                fill: textColor
            })
        ]
    }));
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
